
import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from "@/components/ui/accordion";

const FAQSection = () => {
  return (
    <section className="py-8 sm:py-12 px-4 sm:px-6 bg-[#FAF9F6]">
      <div className="max-w-2xl mx-auto">
        <h2 
          className="text-2xl sm:text-3xl font-bold text-center text-gray-900 mb-6"
          style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
        >
          ¿Tienes dudas?
        </h2>
        
        <Accordion type="single" collapsible className="w-full">
          <AccordionItem value="item-1" className="bg-white rounded-lg shadow-sm border border-gray-200">
            <AccordionTrigger 
              className="px-6 py-4 text-left font-medium text-gray-900 hover:no-underline"
              style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
            >
              ¿Qué pasa después de los 7 días?
            </AccordionTrigger>
            <AccordionContent 
              className="px-6 pb-4 text-gray-700 leading-relaxed"
              style={{ fontFamily: 'Inter, system-ui, sans-serif' }}
            >
              Después de la prueba, puedes seguir usando MigranteAmigo por solo $9.99 al mes. Cancela cuando quieras desde tu cuenta — sin llamadas ni complicaciones.
            </AccordionContent>
          </AccordionItem>
        </Accordion>
      </div>
    </section>
  );
};

export default FAQSection;
